// extracted by mini-css-extract-plugin
export default {"page":"Page_page__2dKfq"};